<template>
<!-- 插件 -->
<el-dialog title="新增/编辑" :visible.sync="fromVisible" :before-close="handleClose" @opened="openFrom()">
    <el-form :model="formData" :rules="rules" ref="ruleForm">
      <!-- <el-form-item label="角色编码" :label-width="formLabelWidth" prop="role_code" style="margin-bottom: 17px">
        <el-input v-model="formData.role_code" autocomplete="off" placeholder="请输入角色编码"></el-input>
      </el-form-item> -->
      <el-form-item label="角色名称" :label-width="formLabelWidth" prop="role_name" style="margin-bottom: 17px">
        <el-input v-model="formData.role_name" autocomplete="off" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="选择权限" :label-width="formLabelWidth"  prop="menu" style="margin-bottom: 17px;padding-top:10px">
          <el-tree
          :data="menu_tree"
          show-checkbox
          node-key="id"
          :default-expanded-keys="checked_keys"
          :props="defaultProps" 
          ref="tree"
          >
        </el-tree>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose()">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </div>
</el-dialog>
</template>
<script>
    export default {
        name:"fromRole",
        props:{
            fromVisible:Boolean,   
            role_id:Number,   
        },
        data(){
            return {
                formData:{ },//数据
                checked_keys:[], //目录树默认选中 
                expanded_keys:[], //目录树默认展开 
                formLabelWidth: '120px', //表单宽度 
                menu_tree:[], //菜单目录树 
                defaultProps: { //目录树配置 
                    children: 'children',
                    label: 'label'
                },
                rules: { //验证规则 
                    // role_code: [
                    //     {required: true, message: '请输入角色编码', trigger: 'blur'},
                    // ],
                    role_name: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ]
                },
            }
        },
        created() {
            this.handleMenuTree();
            this.findRole(this.role_id);
        },
        methods: {
            //关闭弹窗 
            handleClose() {
                this.$nextTick(() => {
                    // this.dialogData = {
                    //   app_type: "30",
                    // }
                    // this.$refs.uploads.clearFiles() //清除上传文件对象
                    
                })
                this.$emit('getData');
                this.$emit('handleFromVisible',false);
            // this.dialogVisible = false;
            },
            //目录树 
            handleMenuTree() {
                this.loading = true;
                this.$api.post("/api/menu/getMenusAll", [], res => {
                    if (res.status == 200) {
                        this.menu_tree = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                    //渲染结束后取消加载
                    this.loading = false;
                })
            },
             // 添加表单校验
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                       //获取目录值  
                      let menu_val = this.$refs.tree.getCheckedNodes(false,true).map(i => i.id)//返回选中子节点的key
                    //   let menu_val = fu.concat(zi)
                      if(!menu_val){
                        this.$message.error('请选择目录权限');
                        return false;
                      }
                      this.formData.menu_id  = menu_val.join(',');   
                      let url;
                      if(this.role_id != 0){
                         url = '/api/role/editRole';
                        this.formData.role_id = this.role_id;
                      }else{
                         url = '/api/role/addRole';
                      }
                    // 添加确定
                        this.$api.post(url, this.formData, res => {
                            if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: '操作成功',
                                duration: 1000,
                            });
                            this.handleClose();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //查询角色信息 
            findRole(role_id){
                this.$api.post("/api/role/findRole", {role_id}, res => {
                    if(res.status == 200){
                        const data = res.data;
                        this.formData= data;
                        this.checked_keys = res.data.menu_id.split(",");
                        this.expanded_keys = res.data.menu_id.split(",");
                        this.expanded_keys.forEach((item) => {
                            const root = this;
                            this.$nextTick(()=>{
                                let node = root.$refs.tree.getNode(item);
                                if (node.isLeaf) {//判断是否是子节点
                                    root.$refs.tree.setChecked(node, true);
                                }
                            })
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //清除数据 
            clearData(){
                this.formData = [];
                this.checked_keys = [];
                this.expanded_keys = [];
            },
            
        }
    }
</script>
<style scoped>
    .menu_tree{
        margin-top:10px;
    }
</style>
